<template>
   <div style="width:calc(100%); height:calc(100%); z-index:1">
    <div 
    id="radarChartContainer" 
    ref="radarChartContainer" 
    style="width:calc(100%); 
    height:calc(100%); 
    z-index:1">
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
export default {
   name:'circleChart',
   props:{
     legend: {
       type: Array,
       default: () => {
         return ['一般危险', '较大危险', '高度危险']
       }
     },
     color: {
       type: Array,
       default: () => {
         return ['#598CFF', '#FFC63C','red']
       }
     },
     values: {
       type: Object,
       default: () => {
         return {
           one: 0,
           two: 0,
           three: 0
         }
       }
     },
     mark: {
       type: String,
       default: ""
     }
   },
   data(){
     return{
      option: {}
    }
   },
   created() {

   },
   mounted() {
     this.loadData();
     this.getNext();
      window.onresize = () => {
        return (() => {
            this.getNext()
        })();
      };
    },
  methods:{
      loadData() {
           this.option = {
             tooltip: {
               show:false,
                 trigger: 'item',
                 formatter: "{a} : {c} ({d}%)"
             },
             color: this.color,
             legend: {
             orient: 'horizontal',
			 x:'center',
               itemHeight: 10,//图例的高度
               itemGap: 8,//图例之间的间距
               data: [this.legend[0] + this.values.one + this.mark, this.legend[1] + this.values.two + this.mark, this.legend[2] + this.values.three + this.mark]
              //图例的名字需要和饼图的name一致，才会显示图例
             },
             series: [
               {
                 name: this.legend[0],
                 type:'pie',
                 left: 'center',
				 top:'10px',
                 clockWise: false,
                 radius: ['70%', '78%'],
                 //环的位置
                 label: {
                   show: false,
                   position: 'center',
                 },
                 labelLine: {
                   normal: {
                     show: false
                   }
                 },
                 emphasis: {
                   label: {
                     show: true,
                     fontSize: '14',
                     fontWeight: 'bold'
                   }
                 },
                 data:[
                   {
                     value: this.values.one, //需要显示的数据
                     name: this.legend[0] + this.values.one + this.mark,
                     itemStyle: {
                       normal: {
                         color: '#598CFF'
                       }
                     }
                   },
                   {
                     value:100 - this.values.one,
                     //不需要显示的数据，颜色设置成和背景一样
                     itemStyle: {
                       normal: {
                         color: '#eee'
                       }
                     }
                   }
                 ]
               },
               {
                 name: this.legend[1],
                 type:'pie',
                 left: 'center',
				 top:'10px',
                 clockWise: false,
                 radius: ['50%', '58%'],
                 label: {
                   show: false,
                   position: 'center',
                 },
                 labelLine: {
                   normal: {
                     show: false
                   }
                 },
                 emphasis: {
                   label: {
                     show: true,
                     fontSize: '14',
                     fontWeight: 'bold'
                   }
                 },
                 data:[
                   {
                     value: this.values.two,
                     name: this.legend[1] + this.values.two + this.mark,
                     itemStyle: {
                       normal: {
                         color: '#FFC63C'
                       }
                     }
                   },
                   {
                     value: 100 - this.values.two,
                     itemStyle: {
                       normal: {
                         color: '#eee'
                       }
                     }
                   }
                 ]
               },
               {
                 name: this.legend[2],
                 type:'pie',
                 left: 'center',
				 top:'10px',
                 clockWise: false,
                 radius: ['30%', '38%'],
                 label: {
                   show: false,
                   position: 'center',
                 },
                 labelLine: {
                   normal: {
                     show: false
                   }
                 },
                 emphasis: {
                   label: {
                     show: true,
                     fontSize: '14',
                     fontWeight: 'bold'
                   }
                 },
                 data:[
                   {
                     value: this.values.three,
                     name: this.legend[2] + this.values.three + this.mark,
                     itemStyle: {
                       normal: {
                         color: '#FF7859'
                       }
                     }
                   },
                   {
                     value: 100 - this.values.three,
                     itemStyle: {
                       normal: {
                         color: '#eee'
                       }
                     }
                   }
                 ]
               }
             ]
           }
      },
      getNext() {
          let _that = this
          _that.$nextTick(() => {
          _that.myChart = echarts.init(_that.$refs.radarChartContainer)
                    _that.myChart.setOption(_that.option ,true)
                    _that.myChart.resize()
                    _that.myChart.on('click', function(params) {
                   _that.$emit('echartsClick', params)
                });
            })
      },

  },
}
</script>

<style>

</style>